import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LocationCardEffects, OptionsEffects, UIEffects } from './effects';
import { reducer } from './reducers';
import { locationCardFeatureKey } from './reducers/state';

@NgModule({
    imports: [
        StoreModule.forFeature(locationCardFeatureKey, reducer),
        EffectsModule.forFeature([LocationCardEffects, OptionsEffects, UIEffects]),
    ],
})
export class LocationCardStoreModule {}
